module.exports = __webpack_public_path__ + "img/metabolism-50.e193653e.png";